module.exports = __webpack_public_path__ + "img/backyard-bridge-detail.b7a5b083.webp";